import * as types from '../constants/actionTypes';

export const loginUser = (userCode, password,customerNumber, recaptchaResponse) => ({
  type: types.LOGIN_USER,
  userCode,
  password,
  customerNumber,
  recaptchaResponse
});

export const checkOverUser = (code) => ({
  type: types.CHECK_OVER_USER,
  code
});

export const loginUserSuccess = (token,name,userName) => ({
  type: types.LOGIN_USER_SUCCESS,
  token,
  name,
  userName
});

export const loginUserError = token => ({
  type: types.LOGIN_USER_ERROR,
  token
});

export const setMenu = (menu) => ({
  type: types.SET_MENU,
  menu
});

export const logout = () => ({ type: types.LOGOUT });
export const logoutUser = () => ({ type: types.LOGOUT_USER });
export const tokenRefresh = () => ({ type: types.TOKEN_REFRESH });
export const tokenRefreshSuccess = token => ({ type: types.TOKEN_REFRESH_SUCCESS, token });
export const tokenRefreshError = error => ({ type: types.TOKEN_REFRESH_ERROR, error });
export const timeoutCreate = (timeoutId) => ({ type: types.TIMEOUT_CREATE, timeoutId});

export const setNotification = (message, variant, status) => ({
  type: types.SET_NOTIFICATION,
  message,
  variant,
  status
});

export const clearNotification = (variant) => ({
  type: types.CLEAR_NOTIFICATION,
  variant });
export const initialize = () => ({ type: types.INITIALIZE });
export const clearLogin = () => ({ type: types.CLEAR_LOGIN });
export const switchUser = (userId, fullName, userName) => ({ type: types.SWITCH_USER, userId, fullName, userName });
export const setSwitchedUser = (userId) => ({ type: types.SET_SWITCHED_USER, userId });
